import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about',
  imports: [TranslateModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.setSeoTags();
  }

  private setSeoTags(): void {
    const title = this.translateService.instant('about.seo_title');
    const description = this.translateService.instant('about.seo_description');

    this.titleService.setTitle(title);

    this.metaService.updateTag({
      name: 'description',
      content: description,
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: title,
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: description,
    });
  }
}
